import { useUrlParamsValueToString } from "@harea/component"
import { useMemo } from "react"

type TimeOffTypeLike = { designation?: string }

export const useAppointmentDetailsEditLink = (type: TimeOffTypeLike) => {

    const urlParamsToString = useUrlParamsValueToString()

    return useMemo(() => {
        if (type?.designation === 'ABSENCE') {
            return `edit/missing?${urlParamsToString}`
        }
        return `edit/leave?${urlParamsToString}`
    }, [urlParamsToString])
}
